import React from "react";
import iconimg from "../../../images/Checkmark.svg";

const UtilComponent = ({ info }) => {
   if (!info?.title || !info?.subTitle) return null;

   const { title, subTitle } = info;
   const { step, mainTitle } = title;
   const { mainSubtitle = [], icon } = subTitle;
   const hasStep = step !== false && step !== undefined && step !== null;

   return (
      <div className="mv-info-main-container pop-in-v2">
         <div className="mv-info-border-wrapper">
            <div className="mv-info-container mv-info-step-bg-color">
               <div className="mv-bg-color">
                  <div className="mv-info-title-row">
                     <div className="mv-info-title-wrap">
                        {hasStep && <span className="mv-info-step">{step}</span>}
                        <span className="mv-info-title-text">{mainTitle}</span>
                     </div>
                  </div>
                  <div className="mv-info-step-subtitle-list">
                     {mainSubtitle.map((subtitle, idx) => (
                        <div key={idx} className="mv-info-subtitle">
                           {icon === false && <span className="mv-info-step">{idx + 1}</span>}
                           {icon === true && <img src={iconimg} alt="icon" />}
                           {subtitle}
                        </div>
                     ))}
                  </div>
               </div>
            </div>
         </div>
      </div>
   );
};

export default UtilComponent;
